import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const fastApiBaseUrl =
  import.meta.env.VITE_NODE_ENV === "development"
    ? import.meta.env.VITE_FAST_API_BASE_URL_DEV
    : import.meta.env.VITE_NODE_ENV === "stage"
    ? import.meta.env.VITE_FAST_API_BASE_URL_STAGE
    : import.meta.env.VITE_FAST_API_BASE_URL_PROD;

export const fastApi = createApi({
  reducerPath: "fastApi",
  baseQuery: fetchBaseQuery({ baseUrl: fastApiBaseUrl }),
  tagTypes: ["Products", "BrandDetails", "BrandCart"],
  endpoints: () => ({}),
});
